import { IMenuItem } from 'models/IMenuItem';
import { useState } from 'react';
import { NotifyLink } from 'components/Shared/NotifyLink';
import styles from './styles.scss';
import cn from 'classnames';
import { useTouchStartNavigate } from 'components/MainMenu/useTouchStartNavigate';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { useDispatch } from 'react-redux';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';

interface CategoryItemProps extends IMenuItem {
  isOpen: boolean;
  isLoading: boolean;
  openMenu: () => void;
  closeMenu: () => void;
}

export const CategoryItem = (props: CategoryItemProps) => {
  const { openMenu, closeMenu, isOpen, url, ticket, id, title } = props;
  const [, setRef] = useTouchStartNavigate<HTMLAnchorElement | undefined>(useState(), props);
  const reduxDispatch = useDispatch();

  const handleOnClick = () => {
    reduxDispatch(GtmHeaderNavClick(url));
  };

  return (
    <li onMouseOver={openMenu} onMouseOut={closeMenu} className={cn({ [styles.open]: isOpen })}>
      <NotifyLink
        onClick={handleOnClick}
        url={url}
        ticket={ticket}
        setRef={setRef}
        {...getQaDataAttr(`link-nav-${id}`)}
      >
        {title}
      </NotifyLink>
    </li>
  );
};
